import { Component, signal } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'md-group-cell-renderer',
  imports: [],
  templateUrl: './group-cell-renderer.component.html',
  styleUrl: './group-cell-renderer.component.scss',
  standalone: true
})
export class GroupCellRendererComponent implements ICellRendererAngularComp {
  values = signal<unknown[]>([]);

  agInit(params: ICellRendererParams<unknown, unknown, unknown>): void {
    this.refresh(params);
  }

  refresh(params: ICellRendererParams<unknown, unknown, unknown>): boolean {
    this.values.set(Array.isArray(params.value) ? params.value : []);
    return true;
  }
}
